export default {
  getBlacklistFormData: state => state.blacklistFormData,
  getInputBlacklistData: state => key => state.blacklistFormData[key],
}